<template>
  <div class="bg-warning-soft py-4 px-4 md:px-8">
    <header class="mb-2">
      <h4 class="text-xl font-bold">Acceso biométrico</h4>
      <p class="text-slate-700 leading-tight">El acceso a las instalaciones se realizará mediante tarjeta y opcionalmente podrá configurar el reconocimiento facial a través de este equipo.</p>
    </header>
    <template v-if="!finished">
      <div class="rounded-lg bg-white flex flex-col md:flex-row items-center justify-between p-2 mt-4 shadow">
        <div class="flex items-center space-x-2 md:space-x-0 w-full overflow-hidden py-2 md:py-0 justify-center md:justify-start">
          <img src="@/assets/img/facePhoto.svg" class="pl-1 pr-2" />
          <p class="truncate">Iniciar reconocimiento facial</p>
        </div>
        <base-button mode="primary" custom="w-full md:w-auto flex-shrink-0" text="Tomar foto" :disabled="!privacy" @click="start" />
      </div>
      <p class="mt-2">
        <el-checkbox v-model="privacy">
          <span class="text-sm">
            He leído y acepto la
            <a href="#" target="_blank" @click.prevent="legalModal=true" class="underline text-secondary hover:text-secondary-600 font-semibold">política de privacidad</a>
          </span>
        </el-checkbox>
      </p>
    </template>
    <template v-else>
      <div class="rounded-lg bg-white flex flex-col md:flex-row items-center justify-between p-2 mt-4 shadow">
        <div class="flex items-center space-x-2 md:space-x-0 w-full overflow-hidden py-2 md:py-0 justify-center md:justify-start">
          <img src="@/assets/img/faceOk.svg" class="pl-1 pr-2" />
          <p class="truncate">Proceso realizado con <strong class="text-green-600">éxito</strong></p>
        </div>
        <el-button type="danger" custom="w-full md:w-auto flex-shrink-0" @click="cancel">Cancelar</el-button>
      </div>
    </template>

    <div
      :class="{'translate-y-full':!legalModal}"
      class="absolute bottom-0 left-0 w-full h-full z-50 flex items-end transform transition-transform"
    >
      <div
        class="bg-white flex flex-col max-h-[400px] mt-auto overflow-hidden rounded-t-3xl legal-shadow"
      >
        <div class="p-8 prose h-full overflow-auto">
          <h4 class="text-xl font-bold">Política de privacidad</h4>
          <p>Los datos suministrados en el presente formulario serán tratados por el RGCC como responsable habiendo nombrado DPD (dirección electrónica lopd@rgcc.es) y se tratan con la finalidad de verificar su identidad para el acceso a las instalaciones del responsable, la categoría de los datos tratados se encuadra dentro de los identificativos y biohash.</p>
          <p>No se tratan los datos para la elaboración de perfiles, siendo la base de legitimización el artículo 6.1.a) del RGPD consentimiento expreso y libre del interesado, no se prevé la cesión de los datos a ningún tercero ni la transferencia a ningún país fuera de la UE, los datos serán conservados mientras dure su relación con el RGCC y se suprimirán en un máximo de 48 horas desde la finalización de la misma.</p>
          <p>Puede revocar su consentimiento (directamente en este mismo formulario) o ejercer sus derechos de acceso, rectificación, supresión, oposición y limitación a la dirección electrónica del responsable lopd@rgcc.es o a través de su DPD.</p>
          <p>Todos los datos del presente formulario son obligatorios y deben ser veraces.</p>
          <p>Si usted considerara que sus derechos no se han respetado podrá dirigirse a la Agencia Española de Protección de Datos, y Calle Jorge Juan, 6, 28001 - Madrid, como Autoridad Independiente de Control en materia de protección de datos de carácter personal.</p>
          <p>Dispone en esta dirección electrónica información completa sobre el tratamiento de estos datos.</p>
        </div>
        <div class="px-8 py-4 border-t border-slate-100 flex-shrink-0 bg-white">
          <base-button mode="primary" custom="w-full" text="Entendido" @click="legalModal=false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BiometricFaceRecognitionConfig',
  props: {
    finished: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      privacy: false,
      legalModal: false
    }
  },
  methods: {
    start: function () {
      this.$emit('start')
    },
    cancel: function () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.legal-shadow {
  box-shadow: 0 0 40px rgb(0 0 0 / 30%);
}
</style>
